import React from 'react';
import style from '../../assets/scss/components/pages/MainPage.module.scss';
import { EBreakpoint } from '../../constants/breakpoints';
import { convertKeysToCamelCase } from '../../helpers/baseHelpers';
import { useMedia } from '../../hooks/useMedia';
import SettingsContent from '../settings-page/SettingsContent';
import { SettingsSidebar } from '../settings-page/sidebar/SettingsSidebar';

export const SettingsPage: React.FC = () => {
  const { wrapper } = convertKeysToCamelCase(style);

  const { down: isMobile } = useMedia(EBreakpoint.MD);

  return isMobile ? (
    <SettingsSidebar />
  ) : (
    <div className={wrapper}>
      <SettingsSidebar />
      <SettingsContent />
    </div>
  );
};
